import { Reveal } from "./Reveal";

export const SectionHeader = ({ index, label, title, description, testId }) => (
    <Reveal className="max-w-3xl">
        <p className="flex items-center gap-3 text-[11px] sm:text-xs font-bold uppercase tracking-[0.22em] text-nx-mute" data-testid={testId ? `${testId}-label` : undefined}>
            {index && <span className="text-nx-lime tabular">{index}</span>}
            {index && <span className="h-px w-8 bg-white/15" aria-hidden="true" />}
            <span>{label}</span>
        </p>
        <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-nx-text leading-[1.08] text-balance">
            {title}
        </h2>
        {description && (
            <p className="mt-5 text-base lg:text-lg leading-relaxed text-nx-sub">{description}</p>
        )}
    </Reveal>
);
